app.service('deliveryBadge', function (modal, html) {
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			$('body').on('click', '.js-delivery-badge-info', function (e) {
				var id = $(this).data('delivery');
				modal.open('delivery-badge-' + id, {
					modifier: html.has('points-on-modal') ? 'remodal-right' : ''
				});
				e.preventDefault();
				e.stopPropagation();
			}).on('click', '.js-section-extend', function () {
				let $parent = $(this).parent();
				let expanded = $parent.attr('data-expanded') == 'true';
				$parent.attr('data-expanded', '' + !expanded);
			});
		}
	}
	return {
		init
	};
});
